module.exports = __webpack_public_path__ + "static/media/Wanda_ZipImage.883dde13.png";